export default __webpack_public_path__ + "static/media/navbar-icon-companies.61063089.svg";